export default {
  metrics: {
    go_lives: 'Total de lanzamientos',
    avg_quality_score: 'Puntuación media de calidad',
    managers: {
      title: 'Gestores de incorporación',
      fields: {
        name: 'Nombre del gestor',
        go_lives: 'Lanzamientos',
        avg_quality_score: 'Punt. media de calidad',
      },
    },
  },
  details: {
    name: 'Restaurante',
    owner: 'Nombre del propietario',
    owner_phone: 'Teléfono del propietario',
    owner_email: 'Email del propietario',
    live_from: 'Fecha de lanzamiento',
    onboarding_manager: 'Gestor de incorporación',
    sales_manager: 'Gestor de ventas',
    onboarding_quality_score: 'Puntuación de calidad',
    export_csv: 'Exportar CSV',
  },
};
